import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../../../library/checkbox/checkbox';

import { getFilterId } from '../../../../shared/utils/filters/filters';

import './filter-option.scss';

function FilterOption(props) {
  const {
    categoryCode,
    categoryName,
    isSelected,
    label,
    onClick: propsOnClick,
    valueCode,
    valueName
  } = props;
  const type = 'option';
  const filterId = getFilterId({ categoryCode, type, valueCode });

  function onClick() {
    if (typeof propsOnClick === 'function') {
      propsOnClick({
        categoryCode,
        categoryName,
        type,
        valueCode,
        valueName
      });
    }
  }

  return (
    <li className="filter-option" styleName="option">
      <Checkbox
        id={filterId}
        isChecked={isSelected}
        label={label}
        onClick={onClick}
        readOnly
        value={valueCode}
      />
    </li>
  );
}

FilterOption.propTypes = {
  categoryCode: PropTypes.string,
  categoryName: PropTypes.string,
  isSelected: PropTypes.bool,
  label: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  onClick: PropTypes.func,
  valueCode: PropTypes.string,
  valueName: PropTypes.string
};

export default FilterOption;
